module.exports = __webpack_public_path__ + "img/convergence.acf56e29.png";